import * as ActionType from "./organization.type";
import * as ActionType2 from "../admin/admin.type";
import { apiInstanceFetch } from "../../util/api";
import { setToast } from "../../util/toast";
import { apiInstance } from "../../util/api-new";

// Organization Login
export const orgLogin = (login) => (dispatch) => {
  return apiInstance
    .post("organization/login", login)
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType2.LOGIN_ADMIN, payload: res.token });
        setToast("success", "Login Successfully!");

        res.organization.isOnboarded
          ? res.user.invitationStatus === "joined"
            ? (window.location.href = "/org/dashboard")
            : (window.location.href = "/org/register")
          : (window.location.href = "/org/register");
      }
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error.response.data.message);
      return false;
    });
};

// Get Organization for onboarding
export const getOrganization = async () => {
  return apiInstance
    .get("organization/profile")
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return { status: false };
    });
};

export const getOrgUserProfile = async () => {
  return apiInstance
    .get("organization/members/profile")
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return { status: false };
    });
};

export const createOrgDetails = (payload) => async (dispatch) => {
  return apiInstance
    .post("organization/create", payload)
    .then((res) => {
      dispatch({ type: ActionType2.LOGIN_ADMIN, payload: res.data.token });
      return res.status;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

export const resetPassword = (payload) => async (dispatch) => {
  return apiInstance
    .post("organization/reset-password", payload)
    .then((res) => {
      dispatch({ type: ActionType2.LOGIN_ADMIN, payload: res.data.token });
      return res.status;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

export const getSubscriptionPlans = async (currency = "INR") => {
  return apiInstance
    .get(`organization/subscription/plans?currency=${currency}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => []);
};

export const completeSubscription = async (payload) => {
  return apiInstance
    .post("organization/subscription/complete", payload)
    .then((res) => {
      return res.status;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
};

// Get Organizations
export const getOrganizations = (query) => (dispatch) => {
  const queryParams = new URLSearchParams(query);

  apiInstanceFetch.get(`admin/organization?${queryParams}`).then((res) => {
    dispatch({
      type: ActionType.GET_ORGANIZATIONS,
      payload: {
        organizations: res.data.organizations,
        totalOrganizations: res.data.totalOrganizations,
      },
    });
  });
};

// Add Organization
export const addOrganization = (organizationData) => async (dispatch) => {
  return apiInstanceFetch
    .post("admin/organization/register", organizationData)
    .then((res) => {
      if (res.status) {
        setToast("success", res.message);
      } else {
        setToast("error", res.message || res.error);
      }
      return res.status;
    })
    .catch((error) => {
      setToast("error", "Something went Wrong");
      return false;
    });
};

// Update Organization
export const updateOrganization =
  (organizationId, updatedData) => (dispatch) => {
    try {
      // Simulating API call
      setTimeout(() => {
        dispatch({
          type: ActionType.UPDATE_ORGANIZATION,
          payload: {
            organizationId,
            updatedData,
          },
        });
      }, 500);
    } catch (error) {}
  };

// Delete Organization
export const deleteOrganization = (organizationId) => (dispatch) => {
  try {
    // Simulating API call
    setTimeout(() => {
      dispatch({
        type: ActionType.DELETE_ORGANIZATION,
        payload: organizationId,
      });
    }, 500);
  } catch (error) {}
};

// Select Organization
export const selectOrganization = (organization) => (dispatch) => {
  dispatch({
    type: ActionType.SELECT_ORGANIZATION,
    payload: organization,
  });
};

// Toggle Organization Status
export const toggleOrganizationStatus = (organizationId) => (dispatch) => {
  try {
    // Simulating API call
    setTimeout(() => {
      dispatch({
        type: ActionType.TOGGLE_ORGANIZATION_STATUS,
        payload: { organizationId },
      });
    }, 300);
  } catch (error) {}
};

export const getOrgProfile = () => (dispatch) => {
  try {
    apiInstance.get("organization/members/profile").then((res) => {
      dispatch({
        type: ActionType.GET_ORG_PROFILE,
        payload: res.data.organization,
      });
    });
  } catch (error) {}
};

export const updateOrgDetails = (payload) => (dispatch) => {
  try {
    apiInstance.put("organization/update-profile", payload).then((res) => {
      dispatch({
        type: ActionType.UPDATE_ORG_PROFILE,
        payload: res.data,
      });
    });
  } catch (error) {}
};

export const checkSubscriptionApi = async () => {
  return apiInstance.get("organization/subscription/check").then((res) => {
    return res.status;
  });
};
